import { DATE_FORMATS, TIME_ZONE } from "@utilities/dates";
import clsx from "clsx";
import { isSameDay } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { EventDetailProps } from "../C37.5_EventDetail";
import styles from "../C37.5_EventDetail.module.scss";

import IconCalendar from "../../../public/image/svg/calendar.svg";
import IconDuration from "../../../public/image/svg/duration.svg";

const DateTimeSection = (
  props: Pick<EventDetailProps, "eventStarts" | "eventEnds">
) => {
  const { eventStarts, eventEnds } = props;
  const showEventEndTime = eventStarts && eventEnds;

  const formattedEventStartDate = formatInTimeZone(
    eventStarts,
    TIME_ZONE,
    DATE_FORMATS.full
  );
  const formattedEventEndDate = formatInTimeZone(
    eventEnds,
    TIME_ZONE,
    DATE_FORMATS.full
  );
  const formattedEventStartTime = formatInTimeZone(
    eventStarts,
    TIME_ZONE,
    DATE_FORMATS.time
  );
  const formattedEventEndTime = formatInTimeZone(
    eventEnds,
    TIME_ZONE,
    DATE_FORMATS.time
  );

  const oneDayEvent: boolean =
    eventStarts !== null &&
    eventEnds !== null &&
    isSameDay(eventStarts, eventEnds);
  const renderDataTime = () => {
    if (oneDayEvent) {
      return <h3>{formattedEventStartDate}</h3>;
    }

    return (
      <>
        {eventStarts && (
          <>
            {eventEnds && <p className="small">From: </p>}
            <h3>{formattedEventStartDate}</h3>
          </>
        )}

        {eventEnds && (
          <>
            <p className="small">To: </p>
            <h3>{formattedEventEndDate}</h3>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <p className={clsx("label", styles.label)}>
        <IconCalendar aria-hidden />
        Date
      </p>

      {renderDataTime()}

      <p className={clsx("label", styles.label)}>
        <IconDuration aria-hidden />
        Time
      </p>
      {showEventEndTime && (
        <h3>{`${formattedEventStartTime} - ${formattedEventEndTime}`}</h3>
      )}
    </>
  );
};

export default DateTimeSection;
